import './assets/style/sass/main.scss'
import './assets/style/sass/mixin.scss'
import './assets/style/css/tailwind.css'
import './assets/style/css/style.css'
import VeeValidate, { Validator } from 'vee-validate'
import fr from 'vee-validate/dist/locale/fr'
import SvgIcon from 'vue-svgicon'
import { ClientTable } from 'vue-tables-2'
import '@/components/icons'
import DrawerLayout from 'vue-drawer-layout'
import Upload from 'vue-image-crop-upload'
import VCalendar from 'v-calendar'
import AutocompleteVue from 'autocomplete-vue'
export default {
  install (Vue, options) {
    Vue.use(VeeValidate)
    Validator.localize('fr', fr)
    Vue.use(SvgIcon, {
      tagName: 'svgIcon'
    })
    Vue.use(ClientTable)
    Vue.use(DrawerLayout)
    Vue.use(Upload)
    Vue.use(VCalendar, {
      componentPrefix: 'vc'
    })
    Vue.component('autocomplete-vue', AutocompleteVue)
  }
}
